import { DayOfWeek } from '@Generated/back-office-client/src'
import { parse, format } from 'date-fns'

export const DAY_ORDER: DayOfWeek[] = [
  DayOfWeek.MON,
  DayOfWeek.TUE,
  DayOfWeek.WED,
  DayOfWeek.THU,
  DayOfWeek.FRI,
  DayOfWeek.SAT,
  DayOfWeek.SUN,
]

const DAY_LABELS: Record<string, string> = {
  [DayOfWeek.MON]: 'Mon',
  [DayOfWeek.TUE]: 'Tue',
  [DayOfWeek.WED]: 'Wed',
  [DayOfWeek.THU]: 'Thu',
  [DayOfWeek.FRI]: 'Fri',
  [DayOfWeek.SAT]: 'Sat',
  [DayOfWeek.SUN]: 'Sun',
}

export const formatDayOfWeek = (d: DayOfWeek): string => DAY_LABELS[d] ?? String(d)

export const formatDaysOfWeek = (days?: DayOfWeek[] | null): string => {
  if (!days || days.length === 0) {
    return ''
  }
  const sorted = [...days].sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b))
  return sorted.map(formatDayOfWeek).join(', ')
}

const HHMM_REGEX = /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/

export const isValidHHmm = (value: string): boolean => /^([01]\d|2[0-3]):[0-5]\d$/.test(value)

export const formatTime = (time?: string | null): string => {
  if (!time || !HHMM_REGEX.test(time)) {
    return time ?? ''
  }
  const hhmm = time.slice(0, 5)
  const parsed = parse(hhmm, 'HH:mm', new Date())
  return format(parsed, 'h:mm a')
}
